export default __webpack_public_path__ + "static/media/sign-up-background.90d2effa.jpg";